<template>
  <div id="covid19-infantil" class="row">
    <div class="col-md-12">
      <selects
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      ></selects>
    </div>
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <Subtitle
            @exibirVermelhos="handleExibirVermelhos"
            @exibirVerdes="handleExibirVerdes"
            :setRed="setRed"
            :disabledRed="disabledRed"
            :disabledGreen="disabledGreen"
            @resetarNome="setRed = false"
          ></Subtitle>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="covid19-infantil"
          >
          </download-files>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import Subtitle from './Subtitle'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import Selects from '@/components/utils/Selects.vue'
export default {
  name: 'Covid19InfantilPorEquipeAcs',
  components: {
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
    Selects,
  },
  mixins: [utils],
  data() {
    return {
      equipe: '',
      cadastros: [],
      nome: '',
      idade_inicial: '',
      idade_final: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
      nomeEquipe: '',
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      cadastrosOriginais: [],
      setRed: false,
      equipeEvent: '',
      disabledRed: false,
      disabledGreen: false,
      situacao_opcoes: [
        {
          situacao: '11 - 12 anos',
        },
        {
          situacao: '13 - 14 anos',
        },
      ],
      situacao: '',
      disabledSelectEquipe: true,
      loadingSelectEquipe: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
      cadastrosOriginaisEquipe: [],
      microArea: null,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      this.cadastros = this.cadastrosOriginais
      let response = Filter.filtro(
        this.cadastros,
        this.microArea,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes
      )
      if (response === undefined) {
        response = []
      }
      return response
    },
    equipes() {
      let data = this.$store.getters['getEquipes']
      return this.removeDuplicate(data, 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    handleExibirVermelhos(event) {
      this.loading = true
      this.disabledRed = true
      this.disabledGreen = true
      setTimeout(() => {
        if (event == true) {
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
        } else {
          this.exibirCadastrosVermelhos = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    handleExibirVerdes(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      setTimeout(() => {
        if (event == true) {
          this.exibirCadastrosVerdes = true
          this.exibirCadastrosVermelhos = false
        } else {
          this.exibirCadastrosVerdes = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }

      if (event !== null) {
        this.equipeEvent = event
        this.equipe = event
        try {
          this.loading = true
          const response = await Functions.getDadosPorEquipe(
            this.$store.state.cod_ibge,
            this.equipe.nu_ine
          )
          this.cadastrosOriginaisEquipe = response
          this.cadastrosOriginais = response
          this.cadastros = response
          this.setRed = true
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      } else {
        this.cadastrosOriginaisEquipe = []
        this.cadastrosOriginais = []
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = false
        this.equipeEvent = ''
        this.equipe = ''
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }

      this.microArea = event
      if (event != null) {
        this.cadastrosOriginais = this.cadastrosOriginaisEquipe.filter((el) => {
          return el.micro_area == event.micro_area
        })
        this.cadastros = this.cadastrosOriginaisEquipe.filter((el) => {
          return el.micro_area == event.micro_area
        })
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
        this.setRed = true
      } else {
        await this.onChangeEquipe(this.equipeEvent)
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipeEvent,
        this.microArea != null ? this.microArea.micro_area : ''
      )
    },
  },
}
</script>

<style>
#covid19-infantil .select-situacao .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#covid19-infantil .select-situacao .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#covid19-infantil .select-situacao .v-select {
  width: 296px;
}
#covid19-infantil .select-situacao .vs__dropdown-toggle {
  background-color: #fff;
}
</style>
